var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#801950;stroke-width:18.86;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_859"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1385",
    className: "st0",
    d: "M256,59c108.8,0,197,88.2,197,197s-88.2,197-197,197S59,364.8,59,256S147.2,59,256,59 L256,59z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppo_di_maschere_136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plus"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linea_70",
    className: "st1",
    x1: 256,
    y1: 172.9,
    x2: 256,
    y2: 339.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_71",
    className: "st1",
    x1: 339.1,
    y1: 256,
    x2: 172.9,
    y2: 256
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddButton);
export default __webpack_public_path__ + "static/media/add_button.44c9429ccb5cebbf4246d2d05abcffe6.svg";
export { ForwardRef as ReactComponent };